import nodemailer from 'nodemailer'

export default class Email {
    /** The mail transporter */
    public static transporter = nodemailer.createTransport({
        service: process.env.EMAIL_SERVICE,
        host: process.env.EMAIL_HOST,
        port: Number(process.env.EMAIL_PORT),
        secure: process.env.EMAIL_SECURE === 'true',
        auth: {
            user: process.env.EMAIL_USER,
            pass: process.env.EMAIL_PASSWORD
        }
    })

    /** The mail options */
    public static async send(mailOptions: {
        to: string
        subject: string
        replyTo?: string
    } & (
        {
            text: string
        } | {
            html: string
        }
    )) {
        global.executions.addLine({className: "Email",functionName: "send",hierarchy: ["/backend/email/email.ts", "Email", "send"],fileName: "/backend/email/email.ts",childLine: 28,line: "        return new Promise<void>((res, rej) => {"});
        return new Promise<void>((res, rej) => {
            global.executions.addLine({className: "Email",functionName: "[anonymous]",hierarchy: ["/backend/email/email.ts", "Email", "send", "[anonymous]"],fileName: "/backend/email/email.ts",childLine: 29,line: "            this.transporter.sendMail({...mailOptions, from: '\"Hurx\" <webmaster@hurx.io>'}, (error, info) => {"});
            this.transporter.sendMail({...mailOptions, from: '"Hurx" <webmaster@hurx.io>'}, (error, info) => {
                if (error) {
                    global.executions.addLine({className: "Email",functionName: "[anonymous]",hierarchy: ["/backend/email/email.ts", "Email", "send", "[anonymous]", "[anonymous]"],fileName: "/backend/email/email.ts",childLine: 31,line: "                    console.error(error)"});
                    console.error(error)
                    global.executions.addLine({className: "Email",functionName: "[anonymous]",hierarchy: ["/backend/email/email.ts", "Email", "send", "[anonymous]", "[anonymous]"],fileName: "/backend/email/email.ts",childLine: 32,line: "                    return rej(error)"});
                    return rej(error)
                }
                global.executions.addLine({className: "Email",functionName: "[anonymous]",hierarchy: ["/backend/email/email.ts", "Email", "send", "[anonymous]", "[anonymous]"],fileName: "/backend/email/email.ts",childLine: 34,line: "                console.log(`E-mail sent successfully.`)"});
                console.log(`E-mail sent successfully.`)
                global.executions.addLine({className: "Email",functionName: "[anonymous]",hierarchy: ["/backend/email/email.ts", "Email", "send", "[anonymous]", "[anonymous]"],fileName: "/backend/email/email.ts",childLine: 35,line: "                console.log({error, info})"});
                console.log({error, info})
                global.executions.addLine({className: "Email",functionName: "[anonymous]",hierarchy: ["/backend/email/email.ts", "Email", "send", "[anonymous]", "[anonymous]"],fileName: "/backend/email/email.ts",childLine: 36,line: "                return res()"});
                return res()
            })
        })
    }
}